import { Button } from '@mui/material';
import LargeTooltip from './CustomTooltip';
import { ButtonSpinnerBlue } from './CustomSpinners';

export function SubmitButton({ showSpinner, text, ...props }) {
    return (
        <Button
            variant="contained"
            color='primary'
            sx={{ color: 'white', boxShadow: 'none' }}
            disabled={showSpinner}
            {...props}
        >
            {showSpinner ? <ButtonSpinnerBlue /> : text}
        </Button>
    )
}

export function CancelButton(props) {
    return (
        <Button variant='contained' color='inherit' sx={{ color: 'black', boxShadow: 'none' }} {...props}>
            {props.children}
        </Button>
    )
}

export function DangerButton({ showSpinner, text, ...props }) {
    return (
        <Button
            variant="contained"
            color='error'
            sx={{ color: 'white', boxShadow: 'none' }}
            disabled={showSpinner}
            {...props}
        >
            {showSpinner ? <ButtonSpinnerBlue /> : text}
        </Button>
    )
}

export function WarningButton({ showSpinner, text, ...props }) {
    return (
        <Button
            variant="contained"
            color='warning'
            sx={{ color: 'white', boxShadow: 'none' }}
            disabled={showSpinner}
            {...props}
        >
            {showSpinner ? <ButtonSpinnerBlue /> : text}
        </Button>
    )
}

export function MenuButton(props) {
    return (
        <Button variant='contained' color='primary' sx={{ color: 'white' }} {...props}>
            {props.children}
        </Button>
    )
}

export function MenuButtonIcon({
    isIcon, title, text, icon: Icon, iconProps = {}, children, ...props
}) {
  const button = (
    <MenuButton {...props}>
      {children ? children : isIcon ? <Icon {...iconProps} /> : text}
    </MenuButton>
  );

  return isIcon ? (
    <LargeTooltip title={title}>
      {/* Tooltip needs a single element child */}
      <span>{button}</span>
    </LargeTooltip>
  ) : (
    button
  );
}